import { Formik, Form, Field, ErrorMessage } from "formik";
import * as Yup from "yup";
import { useEffect, useState } from "react";
import axios from "axios";
import { getTrusteeInfo, updateTrusteeInfo } from "../../api/server";
import { ThreeDots } from "react-loader-spinner";
import { toast } from "react-toastify";

const validationSchema = Yup.object().shape({
  agencyId: Yup.string().required("Agency ID is required"),
  agencyUserId: Yup.string().required("Agency User ID is required"),
  password: Yup.string()
        .required("Password is required")
        .min(8, "Password must be at least 8 characters")
        .matches(/[A-Z]/, "Password must contain at least one uppercase character")
});

export default function UpdateTrustee() {
  const [initialValues, setInitialValues] = useState({
    agencyId: "",
    agencyUserId: "",
    password: "",
  });
  const [readOnly, setReadOnly] = useState(false);
  const [loading, setLoading] = useState(false);
  const [showPassword, setShowPassword] = useState(false); // 👈 State for toggle

  useEffect(() => {
    const fetchInial = async () => {
      try {
        const res = await getTrusteeInfo();
        if (res?.data?.success) {
          setInitialValues({
            agencyId: res?.data?.data?.agencyId || "",
            agencyUserId: res?.data?.data?.agencyUserId || "",
            password: res?.data?.data?.password || ""
          });
          // setReadOnly(true)

        }
      } catch (error) {
        // Handle error
      }
    };
    fetchInial();
  }, []);

  const handleSubmit = async (values) => {

    // if(values?.password == initialValues.password){
    //     toast.error("Please Change the Password")
    // }
    // else{
        setLoading(true);
        try {
          const res = await updateTrusteeInfo(values);
          // console.log("res>>>>",res)
          if(res?.data?.success){
            toast.success(res?.data?.message)
          }
        } catch (error) {
           toast.error(error?.response?.data?.error || "Something went wrong.");
          console.error(error);
        } finally {
          setLoading(false);
        }

    // }
   
  };

  return (
    <>
    {
        initialValues?.agencyId  &&

        <section className="client-editing mt-5">
        <div className="client-head">
          <h1 className="f18">US Trustee Info</h1>
        </div>
  
        <Formik
          enableReinitialize
          initialValues={initialValues}
          validationSchema={validationSchema}
          onSubmit={handleSubmit}
        >
          {({ handleChange, handleBlur, values }) => (
            <Form>
              <div className="row">
                <div className="col-lg-6">
                  <div className="input_wrap">
                    <label className="label-title">Agency Id</label>
                    <Field
                      name="agencyId"
                      type="text"
                      // readOnly={readOnly}
                      className="form-control"
                    />
                    <ErrorMessage name="agencyId" component="div" className="error text-danger" />
                  </div>
                </div>
  
                <div className="col-lg-6">
                  <div className="input_wrap">
                    <label className="label-title">Agency User Id</label>
                    <Field
                      name="agencyUserId"
                      type="text"
                      // readOnly={readOnly}
                      className="form-control"
                    />
                    <ErrorMessage name="agencyUserId" component="div" className="error text-danger" />
                  </div>
                </div>
  
                {/* Password Field with Toggle */}
                <div className="col-lg-6">
                  <div className="input_wrap position-relative">
                    <label className="label-title">Password</label>
                    <input
                      name="password"
                      type={showPassword ? "text" : "password"}
                      className="form-control"
                      value={values.password}
                      onChange={handleChange}
                      onBlur={handleBlur}
                    />
                    <i
                      className={`fa ${showPassword ? "fa-eye" : "fa-eye-slash"} position-absolute cursor-pointer pt-lg-1`}
                      style={{ top: "20px", right: "15px", cursor: "pointer" }}
                      onClick={() => setShowPassword(!showPassword)}
                      aria-hidden="true"
                    ></i>
                    <ErrorMessage name="password" component="div" className="error text-danger" />
                  </div>
                </div>
              </div>
  
              <div className="text-center my-3">
                <button type="submit" className="btn_brnd" disabled={loading}
                >
                {loading ? (
                   <ThreeDots
                     height="20"
                     width="65"
                     radius="9"
                     color="#4fa94d"
                     ariaLabel="three-dots-loading"
                     wrapperStyle={{
                       display: "block",
                     }}
                     wrapperClassName="spinner"
                     visible={true}
                   />
                 ) : (
                   "Update"
                 )}
                 </button>
                 
              </div>
            </Form>
          )}
        </Formik>
      </section>
    }
 </>
  );
}
